import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import forOwn from 'lodash/forOwn';
export { CONTRACT_SUMMARY_PAGE, MAKE_PAYMENT_PAGE, MANAGE_PAYMENT_PAGE, mapPageToGaEvents } from './pageToGaEventMapping.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var startFormInteractionGaTag = {
  event: 'form-interaction',
  interaction: 'personal-info-start',
  formType: 'configurator payment form',
  engagementType: 'User Requested'
};
var pushGAInteraction = function pushGAInteraction(interactionObject) {
  if (window.dataLayer && window.dataLayer.push) {
    window.dataLayer.push(interactionObject);
  }
};
var gaInteractionHandler = function gaInteractionHandler(gaData) {
  if (gaData) {
    pushGAInteraction(gaData);
  }
};

/**
 * Append a string prefix to every keys in the provided object
 * @param {string} prefix
 * @param {object} obj
 */
var prefixObject = function prefixObject(prefix, obj) {
  var objCopy = {};
  forOwn(obj, function (value, key) {
    objCopy[key] = "".concat(prefix, " - ").concat(value);
  });
  return objCopy;
};
var wrapGaLabel = function wrapGaLabel(event, interaction, gaLabels) {
  return Object.keys(gaLabels).reduce(function (prev, label) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, label, {
      event: event,
      interaction: interaction,
      label: gaLabels[label]
    }));
  }, {});
};

// GA wrapper to create widget interaction events
var wrapWidgetInteraction = function wrapWidgetInteraction(gaLabels) {
  return Object.keys(gaLabels).reduce(function (prev, label) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, label, {
      event: 'widget-interaction',
      'widget name': gaLabels[label]
    }));
  }, {});
};

// GA wrapper to wrap configurator interaction events
var wrapConfiguratorInteraction = function wrapConfiguratorInteraction(event, cfgType, gaLabels) {
  return Object.keys(gaLabels).reduce(function (prev, label) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, label, {
      event: event,
      interaction: gaLabels[label],
      'cfg-type': cfgType
    }));
  }, {});
};
var wrapFormInteractionTag = function wrapFormInteractionTag(event, formType, engagementType, gaLabels) {
  return Object.keys(gaLabels).reduce(function (prev, label) {
    return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, label, {
      event: event,
      formType: formType,
      engagementType: engagementType,
      interaction: gaLabels[label]
    }));
  }, {});
};
var BUSINESS_UNITS = {
  energy: 'Energy',
  vehicle: 'Vehicle'
};
var PRODUCT_STATES = {
  preDelivery: 'PreDelivery',
  ownership: 'Ownership'
};
var PRODUCTS = _defineProperty(_defineProperty({}, BUSINESS_UNITS.vehicle, {
  modelS: 'Model S',
  modelX: 'Model X',
  model3: 'Model 3'
}), BUSINESS_UNITS.energy, {
  powerwall: 'Powerwall',
  solarPanels: 'Solar Panels',
  solarRoof: 'Solar Roof',
  homeCharging: 'Home Charging'
});
var VirtualPageview = /*#__PURE__*/function () {
  function VirtualPageview(businessUnit, productState, product) {
    _classCallCheck(this, VirtualPageview);
    this.event = {
      event: 'virtualPageview'
    };
    this.allowedBusinessUnits = Object.values(BUSINESS_UNITS);
    this.allowedProductStates = Object.values(PRODUCT_STATES);
    this.allowedProducts = Object.values(PRODUCTS[BUSINESS_UNITS.energy]).concat(Object.values(PRODUCTS[BUSINESS_UNITS.vehicle]));
    this.updateConfiguration({
      businessUnit: businessUnit,
      productState: productState,
      product: product
    });
    this.updateConfiguration = this.updateConfiguration;
    this.pushPageview = this.pushPageview;
  }
  return _createClass(VirtualPageview, [{
    key: "pushPageview",
    value: function pushPageview(pageviewObject) {
      if (pageviewObject.virtualPageUrl) {
        var interactionObject = _objectSpread(_objectSpread({}, this.event), pageviewObject);
        // if no virtualPageTitle use the virtualPageUrl for the title as well
        if (!interactionObject.virtualPageTitle) {
          interactionObject.virtualPageTitle = interactionObject.virtualPageUrl;
        }
        pushGAInteraction(interactionObject);
      }
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "getValidatedOption",
    value: function getValidatedOption(option, allowedOptions, errorLogDescriptor) {
      var trimmedOption = option.trim();
      var isValid = allowedOptions.indexOf(trimmedOption) > -1;
      if (!isValid && errorLogDescriptor) {
        // eslint-disable-next-line no-console
        console.warn("VirtualPageview: Invalid ".concat(errorLogDescriptor, " - ").concat(trimmedOption));
      }
      return isValid ? trimmedOption : '';
    }
  }, {
    key: "updateConfiguration",
    value: function updateConfiguration(config) {
      var _this = this;
      if (config.businessUnit) {
        this.event.MyTeslaBusinessUnit = this.getValidatedOption(config.businessUnit, this.allowedBusinessUnits, 'Business Unit');
        if (this.event.MyTeslaBusinessUnit) {
          this.allowedProducts = Object.values(PRODUCTS[this.event.MyTeslaBusinessUnit]);
        }
      }
      if (config.productState) {
        this.event.MyTeslaProductState = this.getValidatedOption(config.productState, this.allowedProductStates, 'Product State');
      }
      if (config.product) {
        if (this.event.MyTeslaBusinessUnit === BUSINESS_UNITS.energy) {
          var products = config.product.split(',').map(function (product) {
            return product.trim();
          });
          products = products.filter(function (product) {
            var validatedOption = _this.getValidatedOption(product, _this.allowedProducts, 'Product');
            return !!validatedOption;
          });
          this.event.MyTeslaProduct = products.join(',');
        } else {
          this.event.MyTeslaProduct = this.getValidatedOption(config.product, this.allowedProducts, 'Product');
        }
      }
    }
  }]);
}();
var virtualPageview = new VirtualPageview();

export { BUSINESS_UNITS, PRODUCTS, PRODUCT_STATES, VirtualPageview, gaInteractionHandler, prefixObject, pushGAInteraction, startFormInteractionGaTag, virtualPageview, wrapConfiguratorInteraction, wrapFormInteractionTag, wrapGaLabel, wrapWidgetInteraction };
